import React from 'react'
import PropTypes from 'prop-types'
import './_tracker.scss'
import { useTranslation } from '../../hooks'

export const checkIcon = <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"> <path d="M6 10.7812L13.0627 3.71851L14 4.65584L6 12.6565L2.28133 8.93717L3.21866 7.99984L6 10.7812Z" fill="currentColor"/> </svg>

export const warningIcon = <svg width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7 3h2v6H7V3zm0 8h2v2H7v-2z" fill="currentColor"/></svg>

function Tracker({ items, theme }) {
  const { i18n } = useTranslation();
  const isStatus = theme === 'status';

  // The status theme has no step numbers: a check for done steps, a dot for the current one and a "!" for a rejected one
  const renderNumber = (item, i) => {
    if (!isStatus) return <span className="tracker__number">{item.isComplete ? checkIcon : i + 1}</span>;
    if (item.isRejected) return <span className="tracker__number">{warningIcon}</span>;
    if (item.isComplete) return <span className="tracker__number">{checkIcon}</span>;
    return <span className="tracker__number">{item.isActive && <span className="tracker__dot" />}</span>;
  }

  const renderStateCssClass = (item) => {
    if (item.isRejected) return ' tracker__item--complete tracker__item--rejected';
    if (item.isComplete) return ' tracker__item--complete';
    if (item.isActive) return ' tracker__item--current';
    return ' tracker__item--todo';
  }

  // A segment is filled when the step above it is complete and the step below it has been reached
  const isSegmentDone = (i) => (
    i > 0 && i < items.length && !!items[i - 1].isComplete && !!(items[i].isComplete || items[i].isActive)
  )

  const renderLineCssClass = (i) => {
    let classes = '';
    if (isSegmentDone(i)) classes += ' tracker__item--line-in-done';
    if (isSegmentDone(i + 1)) classes += ' tracker__item--line-out-done';
    return classes;
  }

  return items?.length ? (
    <ol className={`tracker${theme ? ` tracker--${theme}` : ''}`}>
      {items.map((item, i) => (
        <li className={`tracker__item${renderStateCssClass(item)}${renderLineCssClass(i)}`} key={item.title+item.subTitle+i}>
          {renderNumber(item, i)}
          <span className="tracker__labels">
            {!!item.title && <span className="tracker__label">{i18n(item.title)}</span>}
            {!!item.subTitle && <span className="tracker__sub-label">{i18n(item.subTitle)}</span>}
          </span>
        </li>
      ))}
    </ol>
  ) : null
}

Tracker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    isActive: PropTypes.bool,
    isComplete: PropTypes.bool,
    isRejected: PropTypes.bool,
  })),
  theme: PropTypes.oneOf(['status']),
}

export default Tracker
